


import * as React from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

const SearchComponent = (props) => {
    return (
        <Stack direction="row" spacing={0.5} justifyContent={"flex-end"} >
            <Typography display="inline" mt={1} variant="body2"sx={{fontFamily:'texta-bold',fontSize:'18px', lineHeight:'1.63'}} >Search:</Typography>
            <Tooltip title={props.placeholder}
            // aria-hidden="true" 
                slotProps={{ 
                    popper: { 
                        modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -14],
                },},],},}}
            arrow
              >
                <TextField  label="" inputProps={{style:{fontSize:'12px' } ,'aria-label': 'searchbox'}} size="small" id="outlined-size-normal" value={props?.searchText} onChange={(e)=>props.handleChange(e)} placeholder={props.placeholder}  />
            </Tooltip>
        </Stack>
    )
}

SearchComponent.propTypes = {
    placeholder: PropTypes.string.isRequired,
    handleChange: PropTypes.func,
    searchText: PropTypes.string
    // showSubtitle: PropTypes.bool.isRequired,
    // count:PropTypes.number,
};

export default SearchComponent;